'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shadows = exports.fonts = exports.radii = exports.colors = exports.fontWeights = exports.fontSizes = exports.space = exports.breakpoints = undefined;

var _colors = require('./colors');

Object.defineProperty(exports, 'colors', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_colors).default;
  }
});

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var breakpoints = exports.breakpoints = [32, 48, 64, 80].map(function (n) {
  return n + 'em';
});

var space = exports.space = [0, 4, 8, 16, 32, 64, 128];

var fontSizes = exports.fontSizes = [12, 14, 16, 20, 24, 32, 48, 64, 72, 96];

var fontWeights = exports.fontWeights = {
  normal: 400,
  bold: 700
};

var radii = exports.radii = [0, 2, 4];

var fonts = exports.fonts = {
  0: 'system-ui, sans-serif',
  sans: 'system-ui, sans-serif',
  mono: '"SF Mono", "Roboto Mono", Menlo, monospace'
};

var shadows = exports.shadows = ['none', 'inset 0 0 0 1px ' + _colors2.default.gray, 'inset 0 0 0 1px ' + _colors2.default.gray + ', 0 0 4px ' + _colors2.default.gray];

exports.default = {
  breakpoints: breakpoints,
  space: space,
  fontSizes: fontSizes,
  fontWeights: fontWeights,
  fonts: fonts,
  colors: _colors2.default,
  radii: radii,
  shadows: shadows
};


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/theme.js
// module id = 87
// module chunks = 35783957827783 162898551421021